import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/user/CreateUser.css';
import axios from 'axios';

const CreateUser = () => {
  const [userData, setUserData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (userData.password !== userData.confirmPassword) {
      setError('Passordene stemmer ikke overens');
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/register`, userData, {
        withCredentials: true
      });
      const data = response.data;
      if (data.success) {
        setSuccess(data.message);
        navigate('/login');
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError('Registrering feilet');
    }
  };

  return (
    <div className="create-user-container">
      <form onSubmit={handleSubmit} className="create-user-form">
        <h2>Opprett konto</h2>
        {error && <div className="error-message">{error}</div>}
        <input
          type="text"
          placeholder="Navn"
          value={userData.name}
          onChange={(e) => setUserData({...userData, name: e.target.value})}
        />
        <input
          type="email"
          placeholder="Epost"
          value={userData.email}
          onChange={(e) => setUserData({...userData, email: e.target.value})}
        />
        <input
          type="password"
          placeholder="Passord"
          value={userData.password}
          onChange={(e) => setUserData({...userData, password: e.target.value})}
        />
        <input
          type="password"
          placeholder="Bekreft passord"
          value={userData.confirmPassword}
          onChange={(e) => setUserData({...userData, confirmPassword: e.target.value})}
        />
        <button type="submit">Opprett konto</button>
      </form>
    </div>
  );
};

export default CreateUser; 